import Vue from 'vue';
import { StagesNames, BuddyProgress, InfoBlock } from '../../index.vue';
import { ActiveGroupRejected07085XsSML, ActiveGroupRejected07ML, ActiveGroupRejected07XsS, DownSq, SqNoData, TradingTestFailedBySq, TradingTestFailedByStrategy } from './../infoText';
import BuddyFaq from './BuddyFaq.vue';
import SERVICE_CONSTANTS from '@/constants/services';
export default Vue.extend({
    name: 'buddyMainWidget',
    props: {
        status: {
            type: String,
            required: true
        },
        agreement: {
            type: Boolean,
            required: true
        },
        stages: {
            type: Array,
            required: true
        },
        sqValue: {
            type: String,
            required: true
        },
        info: {
            type: String,
            required: true
        }
    },
    methods: {
        blockElementTitle(progress) {
            return progress === BuddyProgress.notStarted;
        },
        getStageStatus(stageName) {
            return this.stages.find((stage) => stage.name === stageName).progress;
        },
        getCurrentName(name) {
            const progress = this.getStageStatus(name);
            if (name === StagesNames.agreement) {
                const isAccept = !this.agreement && (progress === BuddyProgress.notStarted || progress === BuddyProgress.process);
                return isAccept ? 'accept-agreement' : 'agreement-accepted';
            }
            if (name === StagesNames.APIKey) {
                if (progress === BuddyProgress.process)
                    return 'APIKey-creating';
                if (progress === BuddyProgress.success)
                    return 'APIKey-created';
                return 'APIKey-create';
            }
            if (name === StagesNames.sq) {
                const isFinal = progress === BuddyProgress.success || progress === BuddyProgress.reject;
                return isFinal ? 'sq-computed' : 'compute-sq';
            }
            if (name === StagesNames.testing) {
                const isFinal = progress === BuddyProgress.success;
                return isFinal ? 'trade-tested' : 'trade-testing';
            }
            return 'buddy';
        }
    },
    computed: {
        SERVICE_CONSTANTS() {
            return SERVICE_CONSTANTS;
        },
        showRecommendation() {
            return this.info && this.info !== 'UNKNOWN' && this.info !== 'unknown';
        },
        isInfoBlockString() {
            const stringInfo = [
                InfoBlock.init,
                InfoBlock.creatingApiKey,
                InfoBlock.apiCreatedAnalyzing,
                InfoBlock.tradingTestInProgress,
                InfoBlock.ready
            ];
            return stringInfo.includes(this.info);
        },
        stringInfoBlock() {
            let textKey = '';
            if (this.info === InfoBlock.init)
                textKey = this.agreement ? 'init-apiCreating' : 'init-agreement';
            else
                textKey = this.info;
            return this.$t(`buddyPage.info.${textKey}`);
        },
        componentInfoBlock() {
            var _a, _b;
            return ((_a = this.info[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = this.info) === null || _b === void 0 ? void 0 : _b.substring(1));
        }
    },
    components: {
        BuddyFaq,
        ActiveGroupRejected07085XsSML,
        ActiveGroupRejected07ML,
        ActiveGroupRejected07XsS,
        DownSq,
        SqNoData,
        TradingTestFailedBySq,
        TradingTestFailedByStrategy
    }
});
